module.exports = __webpack_public_path__ + "static/media/GAOFEN 2.e24d68b0.czml";